import React, { useState } from 'react'
import classNames from 'classnames'
import { Box, Grid, makeStyles, createStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { SetBrowserLocationButton } from 'apps/fleet-planner/components/SetBrowserLocationButton'
import { FiltersContainer } from 'apps/fleet-planner/components/bookable-shipment-saved-search/filters/FiltersContainer'
import { ChangeMyLocationModal } from 'apps/fleet-planner/components/modals/ChangeMyLocationModal'
import TruckBookLoads from 'assets/trucks-book-loads.jpg'
import { calcGrid, Toast, TToastNewState, useToastState } from 'transfix-ui'
import { SetBrowserLocationBar } from './SetBrowserLocationBar'

const useStyles = makeStyles(theme =>
  createStyles({
    inner: {
      maxWidth: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: calcGrid(10), // 83.3%
      },
    },
    banner: {
      paddingTop: theme.spacing(12),
    },
    bannerContainer: {
      backgroundImage: `url(${TruckBookLoads})`,
      height: '45%',
      backgroundPosition: 'bottom',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      marginTop: '0px',
      [theme.breakpoints.down('md')]: {
        height: '58% !important',
        marginBottom: theme.spacing(2),
      },
    },
    buttonContainer: {
      position: 'relative',
    },
    title: {
      color: brandColors.white,
      fontWeight: 600,
    },
    locationBtn: {
      position: 'absolute',
      right: '0',
      bottom: '0',
    },
    subtitleBanner: {
      color: brandColors.white,
    },
    textContainer: {
      marginTop: '10px',
    },
    titleContainer: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    },
  })
)

export const BookLoadsBanner = () => {
  const classes = useStyles()
  const { isMobile } = useBreakpointContext()

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const openModalHandler = () => setIsModalOpen(true)
  const closeModalHandler = () => setIsModalOpen(false)

  const { closeToast, openToast, toastMessage, toastOpen, toastType } = useToastState()
  const updateLocationHandler = (toastState: TToastNewState) => {
    openToast(toastState)
  }

  const container = classNames(
    {
      [classes.inner]: isMobile,
      ph4: !isMobile,
    },
    classes.bannerContainer
  )

  const titleClasses = classNames({ [classes.banner]: !isMobile }, classes.titleContainer)

  return (
    <div>
      <Box className={container} mt={5} mb={2}>
        <Box className={titleClasses}>
          <Grid container>
            <Grid item md={8} className={classes.textContainer}>
              <div className={classes.textContainer}>
                <Typography variant='h2' className={classes.title}>
                  Load &apos;em up, move &apos;em out
                </Typography>
              </div>
              <div className={classes.textContainer}>
                <Typography variant='subtitle1' className={classes.subtitleBanner}>
                  Find and book loads for your business
                </Typography>
              </div>
            </Grid>
            <Grid item md={4} className={classes.buttonContainer}>
              <div className={classes.locationBtn}>
                {!isMobile && (
                  <SetBrowserLocationButton onClick={openModalHandler} variant='loadBanner' />
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
        <FiltersContainer />
        {isMobile && <SetBrowserLocationBar onClick={openModalHandler} variant='loadBanner' />}
      </Box>
      {/**
       * This modal is conditionally rendered because it calls a useGeolocation() hook
       * which we don't want prompting the user until the modal is visible
       */}
      {isModalOpen && (
        <ChangeMyLocationModal
          isOpen={isModalOpen}
          onClose={closeModalHandler}
          onSubmitNewLocation={updateLocationHandler}
        />
      )}
      <Toast variation={toastType} open={toastOpen} onClose={closeToast} message={toastMessage} />
    </div>
  )
}
